'use strict';

angular.module('mean.projects').factory('projectWorkOrderPrintService', ['$filter', 'toaster',
    function($filter, toaster) {

        var buildTableBody = function(data, columns) {
            var body = [];

            body.push(columns);
            //var final_total = 0;
            _.each(data, function(row) {
                var dataRow = [];

                _.each(columns, function(column) {
                    if(column === 'total') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'rate'){
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'extra_break_money') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'premium_overtime') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'actual_labor_costs') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'hours') {
                        dataRow.push(row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'bid_hours') {
                        dataRow.push(row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'quantity') {
                        dataRow.push(row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'days_offset') {
                        dataRow.push(row[column].toString());
                    } else if(column === 'delivery_price') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'price_per_order') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'sales_tax') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else if(column === 'direct_labor') {
                        dataRow.push('$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
                    } else {
                        if(row[column])
                          dataRow.push(row[column].toString());
                        else
                          dataRow.push('');
                    }
                })

                //final_total += row['total'];
                body.push(dataRow);
            });

            //change the labels
            _.each(body[0], function(label, idx) {
                if(label == 'task_code') {
                    body[0][idx] = "Task";
                } else if(label == 'task_name') {
                    body[0][idx] = "Name";
                } else if(label == 'bid_hours') {
                    body[0][idx] = "Bid Hours";
                } else if(label == 'actual_man_hours') {
                    body[0][idx] = "Hours";
                } else if(label == 'date') {
                    body[0][idx] = "Date";
                } else if(label == 'days') {
                    body[0][idx] = "# Days";
                } else if(label == 'rate') {
                    body[0][idx] = "Rate";
                } else if(label == 'total') {
                    body[0][idx] = "Total";
                } else if(label == 'hours') {
                    body[0][idx] = "Hours";
                } else if(label == 'foreman_note') {
                    body[0][idx] = "Note";
                } else if(label == 'quantity') {
                    body[0][idx] = "Qty";
                } else if(label == 'delivery_price') {
                    body[0][idx] = "Delivery";
                } else if(label == 'direct_labor') {
                    body[0][idx] = "Direct Labor";
                } else if(label == 'price_per_order') {
                    body[0][idx] = "Price/Order";
                } else if(label == 'sales_tax') {
                    body[0][idx] = "Tax";
                } else if(label == 'name') {
                    body[0][idx] = "Name";
                } else if(label == 'color_code') {
                    body[0][idx] = "Color Scheme";
                } else if(label == 'days_offset') {
                    body[0][idx] = "Days from Start";
                } else if(label == 'start_date') {
                    body[0][idx] = "Start Date";
                } else if(label == 'end_date') {
                    body[0][idx] = "End Date";
                } else if(label == 'bid_note') {
                    body[0][idx] = "Bid Note";
                } else if(label == 'supplier') {
                    body[0][idx] = "Supplier";
                } else if(label == 'number') {
                    body[0][idx] = "#";
                } else if(label == 'description') {
                    body[0][idx] = "Description";
                } else if(label == 'active') {
                    body[0][idx] = "Active";
                } else if(label == 'color_scheme') {
                    body[0][idx] = "Color Scheme";
                } 
            });

            // var empty_row = []
            // var ln = body[0].length;
            // for(var i=0; i<ln; i++)
            //     empty_row.push("");
            // body.push(empty_row);
            
            // ln = body[0].length-2;
            // var total_row = [];
            // for(var i=0; i<ln; i++)
            //     total_row.push("");
            
            // total_row.push({text:"Total: ", bold: true});
            // total_row.push({
            //     text:'$ ' + final_total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
            //     bold: true
            // });
            // body.push(total_row)

            return body;
        };

        var buildLaborTableBody = function(data, columns) {
            var body = [];

            body.push(columns);
            //var final_total = 0;
            _.each(data, function(row) {
                var dataRow = [];

                if(typeof row.days !== 'undefined') {
                    _.each(columns, function(column) {
                        if(column === 'total') {
                            dataRow.push({
                                text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, true],
                            });
                        } else if(column === 'rate'){
                            if(row[column])
                                dataRow.push({
                                    text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                    border: [false, false, false, true],
                                });
                            else
                                dataRow.push({
                                    text: ' ',
                                    border: [false, false, false, true],
                                });
                        } else if(column === 'direct_labor'){
                            dataRow.push({
                                text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, true],
                            });
                        } else if(column === 'hours') {
                            dataRow.push({
                                text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, true],
                            });
                        } else if(column === 'bid_hours') {
                            dataRow.push({
                                text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, true],
                            });
                        } else if(column === 'quantity') {
                            if(row[column]) {
                                dataRow.push({
                                    text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                    border: [false, false, false, true],
                                });
                            } else {
                                dataRow.push({
                                    text: '0.00',
                                    border: [false, false, false, true],
                                });
                            }
                        } else {
                            if(row[column]) {
                              //dataRow.push(row[column].toString());
                              dataRow.push({
                                    text: row[column].toString(),
                                    border: [false, false, false, true],
                                });
                            }
                            else
                              dataRow.push({
                                    text: ' ',
                                    border: [false, false, false, true],
                                });
                        }
                    })
                } else {
                    _.each(columns, function(column) {
                        if(column === 'total') {
                            dataRow.push({
                                text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, false],
                            });
                        } else if(column === 'rate'){
                            if(row[column])
                                dataRow.push({
                                    text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                    border: [false, false, false, false],
                                });
                            else
                                dataRow.push({
                                    text: ' ',
                                    border: [false, false, false, false],
                                });
                        } else if(column === 'direct_labor'){
                            if(row[column])
                                dataRow.push({
                                    text: '$ ' + row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                    border: [false, false, false, false],
                                });
                            else
                                dataRow.push({
                                    text: ' ',
                                    border: [false, false, false, false],
                                });
                        } else if(column === 'hours') {
                            dataRow.push({
                                text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, false],
                            });
                        } else if(column === 'bid_hours') {
                            dataRow.push({
                                text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                border: [false, false, false, false],
                            });
                        } else if(column === 'quantity') {
                            if(row[column])
                                dataRow.push({
                                    text: row[column].toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
                                    border: [false, false, false, false],
                                });
                            else
                                dataRow.push({
                                    text: '0.00',
                                    border: [false, false, false, false],
                                });
                        } else {
                            if(row[column])
                              dataRow.push({
                                text: row[column].toString(),
                                border: [false, false, false, false],
                            });
                            else
                              dataRow.push({
                                text: ' ',
                                border: [false, false, false, false],
                            });
                        }
                    })
                }

                //final_total += row['total'];
                body.push(dataRow);
            });

            //change the labels
            _.each(body[0], function(label, idx) {
                if(label == 'task_code') {
                    body[0][idx] = {
                        text: "Task",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'task_name') {
                    //body[0][idx] = "Name";
                    body[0][idx] = {
                        text: "Name",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'bid_hours') {
                    //body[0][idx] = "Bid Hours";
                    body[0][idx] = {
                        text: "Bid Hours",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'actual_man_hours') {
                    body[0][idx] = "Hours";
                } else if(label == 'date') {
                    body[0][idx] = "Date";
                } else if(label == 'days') {
                    body[0][idx] = "# Days";
                } else if(label == 'rate') {
                    //body[0][idx] = "Rate";
                    body[0][idx] = {
                        text: "Rate",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'total') {
                    //body[0][idx] = "Total";
                    body[0][idx] = {
                        text: "Total",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'direct_labor') {
                    //body[0][idx] = "Total";
                    body[0][idx] = {
                        text: "Direct Labor",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'hours') {
                    //body[0][idx] = "Hours";
                    body[0][idx] = {
                        text: "Hours",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'unit') {
                    //body[0][idx] = "Hours";
                    body[0][idx] = {
                        text: "Units",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'foreman_note') {
                    body[0][idx] = "Note";
                } else if(label == 'quantity') {
                    //body[0][idx] = "Qty";
                    body[0][idx] = {
                        text: "Qty",
                        border: [false, false, false, true],
                        style: 'tableHeader'
                    };
                } else if(label == 'delivery_price') {
                    body[0][idx] = "Delivery";
                } else if(label == 'price_per_order') {
                    body[0][idx] = "Price/Order";
                } else if(label == 'sales_tax') {
                    body[0][idx] = "Tax";
                } else if(label == 'name') {
                    body[0][idx] = "Name";
                } else if(label == 'color_code') {
                    body[0][idx] = "Color Scheme";
                } else if(label == 'color_scheme') {
                    body[0][idx] = "Color Scheme";
                } else if(label == 'days_offset') {
                    body[0][idx] = "Days from Start";
                } else if(label == 'start_date') {
                    body[0][idx] = "Start Date";
                } else if(label == 'end_date') {
                    body[0][idx] = "End Date";
                } else if(label == 'bid_note') {
                    body[0][idx] = "Bid Note";
                } else if(label == 'supplier') {
                    body[0][idx] = "Supplier";
                } else if(label == 'number') {
                    body[0][idx] = "#";
                } else if(label == 'description') {
                    body[0][idx] = "Description";
                } else if(label == 'active') {
                    body[0][idx] = "Active";
                } 
            });

            // var empty_row = []
            // var ln = body[0].length;
            // for(var i=0; i<ln; i++)
            //     empty_row.push("");
            // body.push(empty_row);
            
            // ln = body[0].length-2;
            // var total_row = [];
            // for(var i=0; i<ln; i++)
            //     total_row.push("");
            
            // total_row.push({text:"Total: ", bold: true});
            // total_row.push({
            //     text:'$ ' + final_total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
            //     bold: true
            // });
            // body.push(total_row)

            return body;
        };

        // var buildTaskTableBody = function(data, columns) {
        //     var body = [];

        //     body.push(columns);

        //     var tasks = [];
        //     _.each(data[0].bid_tasks, function(task) {
        //         tasks.push(task.name);
        //     });

        //     var final_total = 0;
        //     _.each(tasks, function(row) {
        //         var dataRow = [];
        //         dataRow.push(row);
        //         _.each(data, function(cost) {
        //             var item = $filter('filter')(cost.bid_tasks, {'name': row}, true);

        //             if(item.length == 1) {
        //                 dataRow.push('$ ' + item[0].total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        //             }
        //         });
        //         body.push(dataRow);
        //     });

        //     var empty_row = []
        //     var ln = body[0].length;
        //     for(var i=0; i<ln; i++)
        //         empty_row.push("");
        //     body.push(empty_row);
            
        //     ln = body[0].length-2;
        //     var total_row = [];
        //     for(var i=0; i<ln; i++)
        //         total_row.push("");
            
        //     total_row.push({text:"Total: ", bold: true});
        //     total_row.push({
        //         text:'$ ' + final_total.toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        //         bold: true
        //     });
        //     body.push(total_row)

        //     return body;
        // };

        var buildTable = function(data, columns) {
            //use the * widths with blank text to center the table on the page
            return {
                columns: [{
                    width: '*', text: ''
                }, {
                    table: {
                        headerRows: 1,
                        body: buildTableBody(data, columns)
                    },
                    width: 'auto',
                    fontSize: 8,
                    layout: 'headerLineOnly'
                }, {
                    width: '*', text: ''
                }]
            }
        };

        // var buildTaskTable = function(data, columns) {
        //     //use the * widths with blank text to center the table on the page
        //     return {
        //         columns: [{
        //             width: '*', text: ''
        //         }, {
        //             table: {
        //                 headerRows: 1,
        //                 body: buildTaskTableBody(data, columns)
        //             },
        //             width: 'auto',
        //             fontSize: 10,
        //             layout: 'headerLineOnly'
        //         }, {
        //             width: '*', text: ''
        //         }]
        //     }
        // };

        var buildLaborTable = function(data, columns) {
            //use the * widths with blank text to center the table on the page
            return {
                columns: [{
                    width: '*', text: ''
                }, {
                    table: {
                        headerRows: 1,
                        body: buildLaborTableBody(data, columns)
                    },
                    width: 'auto',
                    fontSize: 8,
                    //layout: 'headerLineOnly'
                }, {
                    width: '*', text: ''
                }]
            }
        };

        var check = function(string) {
            return (string)?string:"";
        }

        var buildPDF = function(data, show_vars) {
            console.log('buildPDF function');
            var pdf_header = "";
            var pdf_project = "";
            var pdf_proj = "";
            var pdf_ship_to = "";
            var pdf_lot = "";
            var pdf_labor = "";
            var pdf_material = "";
            var pdf_equipment = "";
            var pdf_schedule = "";
            var pdf_color_schemes = "";
            var pdf_options = "";
            var pdf_plan_notes = "";
            var pdf_notes = "";
            var pdf_page_break = "";

            if(show_vars.show_header) {
                if(data.my_trade.logo_one) {
                    pdf_header = [{
                        columns : [{
                            text : show_vars.work_order_title,
                            margin : [ 10,15,0,0 ],
                            style: 'header',
                            width : 300,
                        }, {
                            width: '*',
                            text: '',
                        }, {
                            image: data.my_trade.logo_one,
                            width: 160,
                            height: 50,
                        }],
                        columnGap: 10
                    }, {
                        canvas: [{
                            type: 'line',
                            x1: 10,
                            y1: 0,
                            x2: 595-10,
                            y2: 0,
                            lineWidth: 0.5
                        }]
                    }]
                } else {
                    pdf_header = [{
                        columns : [{
                            text : show_vars.work_order_title,
                            margin : [ 10,15,0,0 ],
                            style: 'header',
                            width : 300,
                        }, {
                            width: '*',
                            text: '',
                        }],
                        columnGap: 10
                    }, {
                        canvas: [{
                            type: 'line',
                            x1: 10,
                            y1: 0,
                            x2: 595-10,
                            y2: 0,
                            lineWidth: 0.5
                        }]
                    }]
                }
            }

            if(show_vars.show_page_break) {
                pdf_page_break = [{ 
                    text: '', 
                    fontSize: 8, 
                    pageBreak: 'before', 
                    margin: [0, 0, 0, 8] 
                }]
            }

            var pdf_col_1 = null;
            var pdf_col_2 = null;

            var selected_lot = $filter('filter')(data.project.lots, {
                'phase': data.lot_selection.phase, 'number': data.lot_selection.lot}, true)[0];

            if(show_vars.contact_information.show) {
                if(show_vars.project_information.client_info) {
                    pdf_col_1 = [
                        {
                            text: 'Client', 
                            style: 'header3'
                        },
                        {
                            stack: [{
                                layout: {
                                    hLineWidth: function hLineWidth(i) {return 0;},
                                    vLineWidth: function vLineWidth(i) { return 0;},
                                    paddingLeft: function(i, node) { return 0; },
                                    paddingRight: function(i, node) { return 0; },
                                    paddingTop: function(i, node) { return 0; },
                                    paddingBottom: function(i, node) { return 0; }
                                },
                                table: {
                                    headerRows: 0,
                                    widths: [90, '*'],
                                    body: [
                                        ['Project: ', check(data.project.name)],
                                        ['Builder: ', check(data.builder.name)],
                                        ['Address: ', check(data.builder.address_one) + ' ' + check(data.builder.address_two)],
                                        ['City, State, ZIP: ', check(data.builder.city) + ', ' + check(data.builder.state) + ' ' + check(data.builder.zip)],
                                        ['Phone: ', check(data.builder.phone)],
                                        ['Email: ', check(data.builder.email)],
                                    ]
                                }
                            }]
                        }
                    ]
                }

                if(show_vars.contact_information.contractor) {
                    pdf_col_2 = [
                    {
                        text: 'Contractor', 
                        style: 'header3'
                    },
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [85, '*'],
                                body: [
                                    ['Name: ', check(data.my_trade.name)],
                                    ['Address: ', check(data.my_trade.address_one) + ' ' + check(data.my_trade.address_two)],
                                    ['City, State, ZIP: ', check(data.my_trade.city) + ', ' + check(data.my_trade.state) + ' ' + check(data.my_trade.zip)],
                                    ['Phone: ', check(data.my_trade.phone)],
                                    ['Email: ', check(data.my_trade.email)],
                                    ['Start Date: ', new moment(selected_lot.start_date).format('MMM D, YYYY')],
                                ]
                            }
                        }]
                    }]
                }

                var temp = [{
                    fontSize: 10,
                    columns: [
                        pdf_col_1,
                        pdf_col_2,
                    ],
                    margin : [ 0,0,0,8 ],
                }]

                var pdf_project = [{
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Contact Information', 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, 
                        temp
                    ]
                }]
            }

            if(show_vars.project_information.show) {
                var proj_col_1 = [
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [80, '*'],
                                body: []
                            }
                        }]
                    }
                ]

                if(show_vars.project_information.project_address) {
                    proj_col_1[0].stack[0].table.body.push(
                        ['Address: ', check(data.project.contact.address_one)],
                    );

                    if(data.project.contact.address_two)
                        proj_col_1[0].stack[0].table.body.push(
                            [' ', check(data.project.contact.address_two)]
                        );

                    proj_col_1[0].stack[0].table.body.push(
                        ['City, State, ZIP: ', check(data.project.contact.city) + ', ' + check(data.project.contact.state) + ' ' + check(data.project.contact.zip)],
                        ['Phone: ', check(data.project.contact.phone)],
                    );
                }

                if(show_vars.project_information.project_manager_info) {
                    proj_col_1[0].stack[0].table.body.push(
                        ['Project Manager: ', check(data.project.trades[0].manager.name)],
                        ['Phone: ', check(data.project.trades[0].manager.phone)],
                        ['Email: ', check(data.project.trades[0].manager.email)]
                    );
                }

                var proj_col_2 = [
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [85, '*'],
                                body: []
                            }
                        }]
                    }
                ]

                if(show_vars.project_information.purchasing_agent_info) {
                    proj_col_2[0].stack[0].table.body.push(
                        ['Purchasing Agent: ', check(data.project.contact.name)],
                        ['Phone: ', check(data.project.contact.phone)],
                        ['Email: ', check(data.project.contact.email)],
                    );
                } else {
                    proj_col_2[0].stack[0].table.body.push([' ']);
                }

                var pdf_proj_cols = {
                    fontSize: 10,
                    columns: [
                        proj_col_1,
                        proj_col_2,
                    ],
                    margin : [ 0,0,0,8 ],
                }
                pdf_proj = [{
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Project Information', 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, 
                        pdf_proj_cols
                    ]
                }]

                //add ship to address info if we have a name
                //and the street address
                if(show_vars.project_information.ship_to_address &&
                    data.project.project_address &&
                    data.project.project_address.name &&
                    data.project.project_address.address) {
                    pdf_proj.push({
                        text: 'Ship To Address:', 
                        style: 'header2a'
                    },
                    {
                        stack: [{
                            margin : [ 0,0,0,8 ],
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [90, '*'],
                                body: [
                                    ['Name: ', check(data.project.project_address.name)],
                                    ['Address: ', check(data.project.project_address.address)],
                                    ['City, State, ZIP: ', check(data.project.project_address.city) + ', ' + check(data.project.project_address.state) + ' ' + check(data.project.project_address.zip)],
                                ]
                            }
                        }]
                    })
                }
            }

            if(show_vars.lot_information.show) {
                var lot_col_1 = [
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [80, '*'],
                                body: []
                            }
                        }]
                    }
                ]

                if(show_vars.lot_information.phase)
                    lot_col_1[0].stack[0].table.body.push(['Phase/Group: ', selected_lot.phase]);

                if(show_vars.lot_information.lot)
                    lot_col_1[0].stack[0].table.body.push(['Lot: ', selected_lot.number]);

                if(show_vars.lot_information.plan)
                    lot_col_1[0].stack[0].table.body.push(['Plan: ', selected_lot.plan]);

                if(show_vars.lot_information.reverse)
                    lot_col_1[0].stack[0].table.body.push(['Reverse: ', (selected_lot.reverse == ' ')?'No':'Yes']);

                var task_str = '';
                _.each(data.task_selection, function(task, idx) {
                    task_str += task.task_code;
                    if(idx+1 < data.task_selection.length)
                        task_str += ', '
                });
                var lot_col_2 = [
                    {
                        stack: [{
                            layout: {
                                hLineWidth: function hLineWidth(i) {return 0;},
                                vLineWidth: function vLineWidth(i) { return 0;},
                                paddingLeft: function(i, node) { return 0; },
                                paddingRight: function(i, node) { return 0; },
                                paddingTop: function(i, node) { return 0; },
                                paddingBottom: function(i, node) { return 0; }
                            },
                            table: {
                                headerRows: 0,
                                widths: [80, '*'],
                                body: []
                            }
                        }]
                    }
                ]

                if(show_vars.lot_information.color_scheme)
                    lot_col_2[0].stack[0].table.body.push(
                        ['Color Scheme: ', (selected_lot.color_scheme == '')?'None':selected_lot.color_scheme]);

                if(show_vars.lot_information.revision)
                    lot_col_2[0].stack[0].table.body.push(['Revision: ', selected_lot.revision]);

                if(show_vars.lot_information.start_date)
                    lot_col_2[0].stack[0].table.body.push(
                        ['Start Date: ', new moment(selected_lot.start_date).format('MMM D, YYYY')]);
                
                lot_col_2[0].stack[0].table.body.push(['Task Codes: ', task_str]);

                var pdf_lot_cols = {
                    fontSize: 10,
                    columns: [
                        lot_col_1,
                        lot_col_2,
                    ],
                    margin : [ 0,0,0,8 ],
                }
                pdf_lot = {
                    margin : [ 0,8,0,8 ],
                    stack: [{
                        text: 'Lot Information', 
                        style: 'header2',
                    },
                    {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, 
                        pdf_lot_cols
                    ]
                }
            }

            if(show_vars.labor.show) {
                var labor_data = [];
                _.each(data.tasks, function(task) {
                    task.start_date = $filter('date')(new Date(task.start_date), 'mediumDate');
                    task.end_date = $filter('date')(new Date(task.end_date), 'mediumDate');
                    var hours = $filter('filter')(data.hours, {'project_task_id': task._id}, true);
                    var number = 0;
                    var rate = 0;
                    task.hours = 0;
                    //task.total = 0;
                    // _.each(hours, function(hour) {
                    //     rate += hour.rate;
                    //     number += 1;
                    //     task.hours += hour.hours;
                    //     //task.total += hour.pay_total;
                    // });

                    task.quantity = 0;
                    task.total = 0;
                    task.direct_labor = 0;
                    _.each(task.subtasks, function(subtask) {
                        task.quantity += parseFloat(subtask.quantity);
                        task.total += parseFloat(subtask.total);
                        task.direct_labor += parseFloat(subtask.current_net_pay);
                    })

                    // if(number)
                    //     task.rate = rate / number;
                    // else
                    //     task.rate = 0;

                    labor_data.push(task)

                    if(!show_vars.labor.tasks_only) {
                        _.each(task.subtasks, function(subtask) {
                            subtask.task_name = subtask.name;
                            subtask.bid_hours = subtask.hours_allowed;
                            subtask.hours_allowed = subtask.hours = 0.0;
                            subtask.rate = (subtask.piece_rate)?subtask.piece_rate:subtask.piece_per_hour_rate;
                            labor_data.push(subtask);
                        });
                    }
                });

                if(show_vars.labor.quantities_of_zero) {
                    _.remove(labor_data, function(labor) {
                        return labor.quantity == 0;
                    });
                }

                if(show_vars.labor.hours_of_zero) {
                    _.remove(labor_data, function(labor) {
                        return labor.bid_hours == 0;
                    });
                }

                if(show_vars.labor.direct_labor_of_zero) {
                    _.remove(labor_data, function(labor) {
                        return labor.total == 0;
                    });
                }

                var table_cols = ['task_code', 'task_name']

                // if(show_vars.labor.bid_hours) {
                //     table_cols.push('bid_hours');
                //     table_cols.push('hours');
                // }

                if(show_vars.labor.hours) {
                    table_cols.push('bid_hours');
                    //table_cols.push('hours');
                }

                if(show_vars.labor.quantity) {
                    table_cols.push('quantity');
                }

                if(show_vars.labor.rate) {
                    table_cols.push('rate');
                }

                if(show_vars.labor.units) {
                    table_cols.push('unit');
                }

                if(show_vars.labor.direct_labor) {
                    table_cols.push('direct_labor');
                }

                pdf_labor = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Labor', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildLaborTable(labor_data, table_cols),
                    ]
                }
            }

            if(show_vars.material.show) {
                var table_cols = ['name'];

                if(show_vars.material.quantity) {
                    table_cols.push('quantity');
                }

                if(show_vars.material.usage_rate) {
                    
                }

                if(show_vars.material.price_per_order) {
                    table_cols.push('price_per_order');
                }

                if(show_vars.material.total_cost) {
                    table_cols.push('total');
                }

                if(show_vars.material.quantities_of_zero) {
                    _.remove(data.materials, function(item) {
                        return item.quantity == 0;
                    });
                }

                pdf_material = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Material', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildTable(data.materials, table_cols),
                    ]
                }
            }

            if(show_vars.equipment.show) {
                var table_cols = ['name'];

                if(show_vars.equipment.quantity) {
                    table_cols.push('quantity');
                }

                if(show_vars.equipment.usage_rate) {
                    
                }

                if(show_vars.equipment.price_per_order) {
                    table_cols.push('price_per_order');
                }

                if(show_vars.equipment.total_cost) {
                    table_cols.push('total');
                }

                if(show_vars.equipment.quantities_of_zero) {
                    _.remove(data.equipment, function(item) {
                        return item.quantity == 0;
                    });
                }

                pdf_equipment = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Equipment', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildTable(data.equipment, table_cols),
                    ]
                }
            }

            if(show_vars.schedule.show) {
                var table_cols = ['task_code', 'task_name'];
                if(show_vars.schedule.days_from_start) {
                    table_cols.push('days_offset');
                }
                if(show_vars.schedule.number_of_days) {
                    table_cols.push('days');
                }
                if(show_vars.schedule.task_start_date) {
                    table_cols.push('start_date');
                }
                if(show_vars.schedule.task_end_date) {
                    table_cols.push('end_date');
                }
                pdf_schedule = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Schedule', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildTable(data.tasks, table_cols),
                    ]
                }
            }

            if(show_vars.color_scheme.show) {
                // if(show_vars.color_scheme.not_selected) {
                //     _.remove(data.options, function(option) {
                //         return option.quantity == 0;
                //     });
                // }

                var col_headers = [];
                col_headers.push('name');
                if(show_vars.color_scheme.bid_note) {
                    col_headers.push('bid_note');
                }
                col_headers.push('color_scheme');
                if(show_vars.color_scheme.bid_note) {
                    col_headers.push('supplier');
                }
                pdf_color_schemes = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Color Scheme', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildTable(data.materials, col_headers),
                    ]
                }
            }

            if(show_vars.options.show) {
                if(show_vars.options.not_selected) {
                    _.remove(data.options, function(option) {
                        return option.quantity == 0;
                    });
                }

                var col_headers = [];
                if(show_vars.options.description) {
                    col_headers = ['number', 'name', 'description', 'quantity', 'direct_labor'];
                } else {
                    col_headers = ['number', 'name', 'quantity', 'direct_labor'];
                }

                pdf_options = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Options', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    },
                    buildTable(data.options, col_headers),
                    ]
                }
            }

            if(show_vars.notes.show && show_vars.notes.plan_notes) {
                var code = '';
                var notes = '';
                //user may select to show plan notes but that doesn't
                //mean they exist
                if(data.trade_notes) {
                    code = data.trade_notes.code;
                    notes = data.trade_notes.notes;
                }

                pdf_plan_notes = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Plan ' + code + ' Notes', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        text: notes,
                        fontSize: 10
                    }]
                }
            }

            if(show_vars.notes.show) {
                pdf_notes = {
                    margin : [ 0,0,0,8 ],
                    stack: [{
                        text: 'Notes', 
                        style: 'header2'
                    }, {
                        canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595-20, y2: 5, lineWidth: 0.5 }],
                        style: "lineSpacing"
                    }, {
                        text: data.notes,
                        fontSize: 10
                    }]
                }
            }

            for(var i=show_vars.order.length-1; i>0; i--) {
                if(show_vars.order[i].label != 'Page Break')
                    break;
                show_vars.order.splice(i, 1);
            }

            var print_sections = [];
            show_vars.order.forEach(function(section) {
                if(section.label == 'Contact Information') {
                    print_sections.push(pdf_project);
                } if(section.label == 'Project Information') {
                    print_sections.push(pdf_proj);
                } else if(section.label == 'Lot Information') {
                    print_sections.push(pdf_lot);
                } else if(section.label == 'Labor') {
                    print_sections.push(pdf_labor);
                } else if(section.label == 'Material') {
                    print_sections.push(pdf_material);
                } else if(section.label == 'Equipment') {
                    print_sections.push(pdf_equipment);
                } else if(section.label == 'Schedule') {
                    print_sections.push(pdf_schedule);
                } else if(section.label == 'Color Scheme') {
                    print_sections.push(pdf_color_schemes);
                } else if(section.label == 'Options') {
                    print_sections.push(pdf_options);
                } else if(section.label == 'Notes') {
                    if(show_vars.notes.plan_notes)
                        print_sections.push(pdf_plan_notes);
                    print_sections.push(pdf_notes);
                } else if(section.label == 'Page Break') {
                    print_sections.push(pdf_page_break);
                }
            })


            console.log('printing...');
            var test = {
                styles: {
                    header: {
                        fontSize: 22,
                        bold: true,
                    },
                    header2: {
                        fontSize: 15,
                        margin:[0,0,0,-4],
                        bold: true,
                    },
                    header2a: {
                        fontSize: 15,
                        margin:[0,0,0,-2],
                        bold: true
                    },
                    header3: {
                        fontSize: 12,
                        margin:[0,0,0,-2],
                        bold: true
                    },
                    anotherStyle: {
                        italics: true,
                        alignment: 'right'
                    },
                    squeezeSpacing: {
                        margin:[0,0,0,0]
                    },
                    lineSpacing: {
                        margin:[0,0,0,6] //change number 6 to increase nspace
                    },
                    tableHeader: {
                        bold: true,
                    }
                },
                pageMargins: [ 10, 65, 10, 20 ],
                pageSize: 'A4',
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Medium.ttf',
                    italics: 'Roboto-Italic.ttf',
                    bolditalics: 'Roboto-Italic.ttf'
                },
                header: pdf_header,
                content: print_sections,
                footer: function(currentPage, pageCount) {
                    return {
                        margin: [10, 0, 10, 0],
                        height: 30,
                        columns: [{
                            text : 'Prepared by: ' + data.user.name,
                            width : 300,
                            //margin: [10,0,0,0]
                        }, {
                            width: '*',
                            text: '',
                        }, {
                            text: currentPage.toString() + ' of ' + pageCount,
                            alignment: 'right',
                            //margin: [0,0,10,0]
                        }]
                    }
                },
                defaultStyle: {
                    font: 'Roboto'
                }
            }
            
            pdfMake.createPdf(test).open();
        };

        return {
            buildPDF: buildPDF,
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/project-work-order-print-service.js